<template>
    <div class="vue-marker-mini-card" @click.prevent="handleClick">
        <div class="row mx-0 d-flex align-center justify-content-center">
            <div class="distance col-auto pl-0 pr-4 d-inline-flex flex-column align-items-center justify-content-center"
                 v-if="hasDistance">
                <span class="kilometers font-weight-bold">{{ marker.distanceFormatted }}</span>
                <span class="unit">{{ distanceIndication }}</span>
            </div>

            <div class="col pl-0 pr-10">
                <h2 class="virtual-p mb-0 font-weight-bold">
                    <button @click="handleClick">{{ marker.title }}</button>
                </h2>
                <p>{{ marker.streetNumber }}</p>

                <p class="office-hours-mini mb-0">
                    <template v-if="isOpen && closingHour">
                        <span class="font-weight-bold">{{ openText }}</span>
                        {{ tillText }} {{ closingHour }}
                    </template>

                    <template v-else>
                        {{ closedText }}
                    </template>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MarkerMiniCard",

    props: {
        marker: {
            type: Object,
            required: true
        },
        eventBus: {},
        domainId: {
            type: String,
        },
    },

    data() {
        return {
            openText: window.Drupal.t('Open'),
            closedText: window.Drupal.t('Closed'),
            tillText: window.Drupal.t('until'),
        }
    },

    computed: {
        isOpen() {
            if (!this.marker.opening_hours) {
                return false;
            }

            return this.marker.opening_hours.isOpen;
        },

        closingHour() {
            if (!this.marker.opening_hours) {
                return false;
            }

            let activeDay = _.find(this.marker.opening_hours.days, (day) => {
                return day.active === true;
            });

            if (_.isEmpty(activeDay.slots)) {
                return false;
            }

            return _.last(activeDay.slots).closed;
        },

        hasDistance() {
            return !_.isNil(this.marker.distanceFormatted);
        },

        distanceIndication() {
            return ('nexdrive_co_uk' === this.domainId) ? 'mi' : 'km';
        }
    },

    methods: {
        handleClick() {
            this.$emit('marker-clicked', this.marker.geolocation);
            this.$emit('active-marker', this.marker);
        },
    }
}
</script>